import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { SidebarItem as SidebarItemType } from './Sidebar';

interface SidebarItemProps {
  item: SidebarItemType;
  isActive: boolean;
  open: boolean;
  onClick: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  item,
  isActive,
  open,
  onClick,
}) => {
  return (
    <ListItem className="sidebarListItem" disablePadding>
      <ListItemButton
        className={isActive ? 'sidebarListButtonActive' : 'sidebarListButton'}
        onClick={onClick}
        sx={{
          justifyContent: open ? 'initial' : 'center',
          px: 2.5,
        }}
      >
        <ListItemIcon
          className={isActive ? 'sidebarIconActive' : 'sidebarIcon'}
          sx={{
            minWidth: 0,
            mr: open ? 3 : 'auto',
          }}
        >
          {item.icon}
        </ListItemIcon>
        <ListItemText
          primary={item.label}
          className={isActive ? 'sidebarTextActive' : 'sidebarText'}
          sx={{
            fontWeight: 500,
            opacity: open ? 1 : 0,
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default SidebarItem;
